export const faqItems = [
  {
    question: '什么是免费建站平台？免费建站真的完全免费吗？',
    answer: '免费建站平台是指提供基础建站功能而不收取费用的在线服务平台，如Wix、Carrd、WordPress.com等。大多数免费建站平台确实提供真正免费的基础套餐，但通常会有限制，如存储空间限制、显示平台广告、使用平台子域名等。对于个人博客、作品集等轻量级需求来说，免费套餐完全够用。如果需要更多功能和自定义域名，可以选择升级到付费套餐。我们建议先用免费套餐体验，确认平台是否适合你之后再决定是否升级。',
  },
  {
    question: '免费域名和付费域名有什么区别？免费域名会影响SEO吗？',
    answer: '免费域名（如Freenom提供的.tk、.ml等）与付费域名（如.com、.net、.cn等）的主要区别在于：1）所有权不同：免费域名的所有权实际上归属于注册国或注册商，而非完全属于你；2）搜索引擎信任度：搜索引擎对免费域名的信任度通常低于付费域名，可能影响排名；3）品牌形象：使用免费域名可能给人不够专业的印象。不过对于测试项目、个人学习或短期项目来说，免费域名仍然是不错的选择。如果打算长期运营，建议投资一个付费域名（年费通常仅几十元）。',
  },
  {
    question: '免费虚拟主机能支撑多大的网站流量？',
    answer: '免费虚拟主机的流量承载能力因服务商而异。以InfinityFree为例，它可以支撑日均数百到数千的访问量，但存在CPU使用限制和并发连接限制。对于新上线的个人博客或小型展示网站来说，免费主机的性能通常足够使用。但当网站流量增长到日均数千独立访客时，建议迁移到付费主机或VPS。我们建议先用免费主机起步，同时关注网站流量数据，在流量接近免费套餐上限时及时升级。',
  },
  {
    question: 'CDN加速是什么？免费CDN和付费CDN差别大吗？',
    answer: 'CDN（内容分发网络）通过在全球各地部署服务器节点，让用户从最近的节点获取网站内容，从而大幅提升访问速度。Cloudflare的免费CDN套餐已经包含了全球300+节点、基础DDoS防护、免费SSL等核心功能。对于绝大多数个人网站和小型企业网站来说，免费CDN的性能已经足够好。付费CDN主要在高级安全防护、更细粒度的缓存控制、专属IP、更低的延迟等方面有优势，适合对性能和安全性有更高要求的大型商业网站。',
  },
  {
    question: '如何选择适合自己的免费建站方案？',
    answer: '选择免费建站方案需要考虑以下几个因素：1）技术能力：如果你没有编程经验，拖拽式建站平台（如Wix、Carrd）是最佳选择；如果你有前端基础，可以使用HTML模板搭配GitHub Pages或Netlify部署；2）网站类型：博客推荐WordPress.com，单页网站推荐Carrd，项目文档推荐GitHub Pages+Jekyll；3）长期规划：考虑未来是否可能需要自定义域名、电商功能等，提前选择支持平滑升级的平台。建议先明确自己的需求和能力水平，再参考本网站的分类资源进行选择。',
  },
  {
    question: '免费SSL证书安全吗？Let\'s Encrypt证书被所有浏览器信任吗？',
    answer: "Let's Encrypt提供的免费SSL证书在安全性上与付费证书没有区别，都使用相同的加密标准。Let's Encrypt的根证书已被所有主流浏览器（Chrome、Firefox、Safari、Edge等）和操作系统信任，使用其证书的网站会在浏览器地址栏显示安全锁图标。唯一的区别是Let's Encrypt只提供域名验证（DV）类型证书，不提供组织验证（OV）或扩展验证（EV）证书。但对于绝大多数网站来说，DV证书已经足够。",
  },
  {
    question: '使用免费建站工具搭建的网站可以赚钱吗？',
    answer: '可以，但需要选择支持商业用途的免费方案。大多数免费建站工具允许个人和商业用途，但需要注意各平台的条款。例如GitHub Pages、Netlify、Vercel的免费套餐都允许托管商业项目。不过，免费套餐通常有一些限制（如带宽上限、不能移除平台标识等），如果你的网站以盈利为目的且流量较大，建议在适当时机升级到付费方案以获得更好的性能和专业形象。另外，免费域名（如.tk）用于商业网站可能会影响用户信任度。',
  },
  {
    question: '我的免费网站如何提升搜索引擎排名？',
    answer: '即使使用免费建站方案，你仍然可以通过以下方式提升SEO表现：1）使用Google Search Console提交站点地图；2）优化页面标题、描述和URL结构；3）创作高质量原创内容；4）确保网站移动端友好；5）提升页面加载速度（可使用免费CDN）；6）建立高质量外链；7）使用免费的SSL证书启用HTTPS。需要注意的是，使用免费子域名（非自定义域名）可能会对SEO产生一定影响，因为搜索引擎对独立域名的信任度更高。',
  },
];

export const faqSchemaData = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};